<template>
  <div class="axj_web_top">
    <div class="web_top_logo">
      <img :src="pageFiles.web_certification_logo_url"/>
    </div>
    <div class="web_top_page_name">
      <label>机构用户认证信息</label>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
  },
  methods:{
    handleMenuItemActive(v){
      for(let x=0; x< this.$refs.menu.children.length;x++){
        this.$refs.menu.children[x].firstChild.firstChild.style.color="#534D63"
        this.$refs.menu.children[x].lastChild.style.visibility="hidden"
      }
      this.$refs[v].lastChild.style.visibility="visible"
      this.$refs[v].firstChild.firstChild.style.color="#ffffff"
      this.$emit("menu-item-change",v)
    }
  },
  name: "axj_certification_top",
  data(){
    return{
      pageFiles:{
        web_certification_logo_url:"https://img.aixuejie.cn/extra/showclub/5_1605171275/5_爱学界_1605171282_38a21fc5df7cebaa4362f0d6058e1032.png",
      }
    }
  }
}
</script>

<style scoped lang="scss">
.axj_web_top{
  height: 72.588px;
  display: flex;
  .web_top_logo{
    height: 100%;
    img{
      margin-top: 17.23px;
      margin-left: 75px;
      height: 38.43px;
    }
  }
  .web_top_page_name{
    display: flex;
    align-items: flex-end;
    margin-top: 18.23px;
    height: 38.43px;
    color: #ffffff;
    font-size: 22px;
    margin-left: 30px;
  }
}
//1400*789

//<1309*717
//@media screen and(max-width: 1310px) and(max-height: 718px) {
//  .axj_web_top{
//    .web_top_logo{
//      img{
//        margin-top: 15.26px;
//        margin-left: 68.17px;
//        height: 36.51px;
//      }
//    }
//    .web_top_menu{
//      .web_top_menu_item{
//        .web_top_menu_item_title{
//          label{
//            font-size: 9px;
//          }
//        }
//      }
//    }
//  }
//}
</style>



// WEBPACK FOOTER //
// src/views/axj_web/axj_certification/component/axj_certification_top/index.vue